import {useEffect} from "react";

export const usePageTitle = (title, triggerValue) => {
    useEffect(() => {
        document.title = title && title !== "null" ? title : "Home";
        window.history.replaceState({}, title, window.location.href);
    }, [triggerValue]);
};